// angular
// 	.module("HeroPRO")
// 	.factory("ProjectHistoryFactory", projectHistoryFactory);

/* @ngInject */
export default function projectHistoryFactory($http, HPConfig) {
    return {
        getProjectHistory,
    };

    function getProjectHistory(params) {
        return $http.get(`${HPConfig.heroProApi}Loan/FundingRequest/ProjectHistory`, {
            params,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/projectHistory/projectHistoryFactory.js